import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import Icon from "./Icon";

export default function InquirySuccess({ booking = false }) {
  const successRef = useRef(null);
  useEffect(() => {
    successRef.current?.focus();
  }, []);
  return (
    <div className="form-success" role="status" tabIndex="-1" ref={successRef}>
      <span className="round-icon">
        <Icon name="check" />
      </span>
      <h2>
        {booking
          ? "Your party inquiry is on its way."
          : "Thanks for getting in touch."}
      </h2>
      <p>We’ve received your message. Our team will follow up with you.</p>
      {booking && (
        <p>
          Your preferred date is a request. Your party is not reserved or
          confirmed until our team confirms availability and booking
          arrangements.
        </p>
      )}
      <Link
        className="button button-secondary"
        to={booking ? "/packagesdetail" : "/#open-play"}
      >
        {booking ? "Back to party packages" : "Explore open play"} <Icon />
      </Link>
    </div>
  );
}
